import { throttle } from 'lodash';
import { useEffect, useRef, useState } from 'react';

export function useScrollDirection(
  scrollableElRef?: React.RefObject<HTMLElement>,
  threshold = 0,
) {
  const [direction, setDirection] = useState<'up' | 'down'>('up');
  const lastY = useRef(0);

  useEffect(() => {
    let el = scrollableElRef?.current;

    if (!el && typeof document !== 'undefined')
      el = document.querySelector('#appWrapper');

    if (!el) return;

    const onScroll = throttle(
      () => {
        const y = el.scrollTop;

        if (y < threshold) {
          setDirection('up');
          lastY.current = y;
          return;
        }

        if (Math.abs(y - lastY.current) < 4) return; // ignore jitter
        setDirection(y > lastY.current ? 'down' : 'up');
        lastY.current = y;
      },
      100,
      { leading: true, trailing: true },
    );
    el.addEventListener('scroll', onScroll);
    return () => {
      el.removeEventListener('scroll', onScroll);
      onScroll.cancel();
    };
  }, [scrollableElRef]);

  return direction;
}
